module.exports = __webpack_public_path__ + "img/chip.ecfd72cf.png";